/*eslint-disable */
var clearTimeoutState;

import {bus} from '@/main';
import covidPopup from '@/components/public/common/covid-19-popup';
import createNewPassword from './create-new-password';
import random_img from '@/assets/images/lange_crub.jpg';
import random_img1 from '@/assets/images/random_img/lange_crub_1.jpg';
import random_img2 from '@/assets/images/random_img/lange_crub_2.jpg';
import random_img3 from '@/assets/images/random_img/lange_crub_3.jpg';
import random_img4 from '@/assets/images/random_img/lange_crub_4.jpg';
import random_img5 from '@/assets/images/random_img/lange_crub_5.jpg';
import resendOtpPopup from '@/components/authentication/resend-otp-popup/';
import toast from '@/services/toast';

const $ = window.jQuery = require('jquery');
// Multi Color Bg Img Of Section
var randomImgLoaded;
var randomImgSlide;

export default {
  name: 'forgot-password-page',
  components: {
    'covid-popup': covidPopup,
    'resend-otp': resendOtpPopup,
    'create-new-password' : createNewPassword
  },
  props: [],
  data() {
    return {
      randomImg: '',
      animationImg: '',
      identity: '',
      otp: '',
      submitted: false,
      emailMblError: false,
      userCheckValidLogin: false,
      userCheckNotValidLogin: true,
      getDetailsOfLoginUser: '',
      userCheckNotValidLoginSecondScreen: false,
      verfiyIdentity: '',
      mblLogined: false,
      signUpFormEnabled: false,
      accept_terms: '',
      firstTimeVisit: sessionStorage.getItem('firstTimeVisit'),
      isMobile:false,
      countDown: 30,
      resentOtpFlag:false,
      login_counter:0,
      resendOtpPopupState:false,
      loginEmailFieldError:false,
      otpEmailFieldError:false,
      enterNewPwScreen:false,
      attempt:1,
      password:'',
      confirm_password:''
    }
  },
  computed: {
  },
  mounted() {
    if (localStorage.getItem('token') != null && localStorage.getItem('LoginedUserID') != null) {
      this.$router.push('/');
    }
    this.animationImg = random_img
    bus.$emit('showHeaderbtn', false);
    this.randomImg = random_img
    this.randomImgSlide()
    this.randomImgLoaded()
    randomImgSlide = setInterval(() => {
      this.randomImgSlide()
    }, 20000);
    randomImgLoaded = setInterval(() => {
      this.randomImgLoaded()
    }, 21500);
    bus.$on('resendOTPLimitStateBus', (data) => {
      this.resendOtpPopupState = data
      this.userCheckNotValidLogin = true
      this.userCheckValidLogin = false
    });
  },
  methods: {
    popupCloseEventMethod(){
      this.$router.push('/');
    },
    onResize() {
      this.isMobile = window.innerWidth < 769
    },
    randomImgSlide() {
      setTimeout(() => {
        $(".oncology_well_new").addClass("active")
        $(".oncology_wel_popup").removeClass("active")
        setTimeout(() => {
          $(".oncology_well_new").css('z-index', '10')
          $(".oncology_wel_popup").css('z-index', '11')
          $(".oncology_wel_line_crub").addClass("animation_play")
        }, 1505)
      }, 10000)
      setTimeout(() => {
        $(".oncology_well_new").removeClass("active")
        $(".oncology_wel_popup").addClass("active")
        setTimeout(() => {
          $(".oncology_wel_popup").css('z-index', '10')
          $(".oncology_well_new").css('z-index', '11')
          $(".oncology_wel_line_crub").removeClass("animation_play")
        }, 1500)
      }, 20000)
    },
    randomImgLoaded() {
      setTimeout(() => {
        this.randomImg = random_img1
      }, 3500)
      setTimeout(() => {
        this.randomImg = random_img
      }, 5500)
      setTimeout(() => {
        this.randomImg = random_img2
      }, 7500)
      setTimeout(() => {
        this.randomImg = random_img
      }, 9500)
      setTimeout(() => {
        this.randomImg = random_img3
      }, 11500)
      setTimeout(() => {
        this.randomImg = random_img
      }, 13500)
      setTimeout(() => {
        this.randomImg = random_img4
      }, 15500)
      setTimeout(() => {
        this.randomImg = random_img
      }, 17500)
      setTimeout(() => {
        this.randomImg = random_img5
      }, 19500)
      setTimeout(() => {
        this.randomImg = random_img
      }, 21500)
    },
    keymonitor() {
      var __self = this
      var ep_emailval = $('#identity').val();
      var intRegex = /[0-9 -()+]+$/;
      if (intRegex.test(ep_emailval)) {
        if ((ep_emailval.length < 7) || (!intRegex.test(ep_emailval))) {
          __self.emailMblError = true
        } else {
          __self.emailMblError = false
          this.mblLogined = true
        }
      } else {
        var eml = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
        if (eml.test(ep_emailval) == false) {
          __self.emailMblError = true
        } else {
          __self.emailMblError = false
          this.mblLogined = false
        }
      }
    },
    validateEmail(email) {
      const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    showNextScreenForLogin() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitted = true;
          let payload = {
            identity: this.identity,
            attempt:this.attempt
          }
          this.$store.dispatch('forgotPwForOtpGenerateAction', payload)
            .then((res) => {
              this.loginEmailFieldError = false
              this.userCheckNotValidLogin = false
              this.userCheckValidLogin = true
              this.countDownTimer();
              toast.success(res.data.data.otp || 'OTP has been sent');
              this.submitted = false;
            }).catch((err) => {
              this.attempt = this.attempt + 1
              this.submitted = false;
              this.loginEmailFieldError = true
            })
          return;
        }
      });
    },
    validateOtpVerifyBeforeSubmit(){
        this.$validator.validateAll().then((result) => {
          this.submitted = true;
          if (result) {
            this.$store.dispatch('optVerifyForForgotPwApiAction', {
              identity: this.identity,
              otp: this.otp,
              attempt:this.attempt
            })
              .then((res) => {
                this.userCheckValidLogin = false
                this.enterNewPwScreen = true
                this.attempt = this.attempt + 1
                this.submitted = false
                toast.success(res.data.data || 'OTP Verified Successfully!');
              }).catch((err) => {
                toast.error(err.data.data.error || 'OTP is not valid!');
                this.attempt = this.attempt + 1
                this.submitted = false
              })
            return;
          }
        });
    },
    validateLoginBeforeSubmit() {
      if (this.userCheckNotValidLogin) {
        this.showNextScreenForLogin();
      }
    },
    userLoginFirstScreenShow() {
      setTimeout(() => {
        this.userCheckValidLogin = false
        this.userCheckNotValidLoginSecondScreen = false
        this.userCheckNotValidLogin = true
      }, 10)
    },
    countDownTimer() {
      if(this.countDown > 0) {
        clearTimeoutState = setTimeout(() => {
                this.countDown -= 1
                this.countDownTimer()
            }, 1000)
        }
    },
    resendOtpMethod() {
      this.submitted = true;
      let login_counter = this.login_counter + 1
      this.login_counter = login_counter
      let payload = {
        identity: this.identity,
        attempt:this.attempt,
        login_counter: login_counter
      }
      this.$store.dispatch('forgotPwForOtpGenerateAction', payload)
        .then((res) => {
          this.loginEmailFieldError = false
          this.userCheckNotValidLogin = false
          this.userCheckValidLogin = true
          this.countDownTimer();
          toast.success(res.data.msg || 'Request processed successfully.');
          this.submitted = false;
        }).catch((err) => {
          this.resendOtpPopupState = true
          toast.error(err.data.data.non_field_errors || err.data.msg);
          this.submitted = false;
        })
    },
    maskString(fieldStr, digits, type = "") {
      let str = fieldStr;
      let domain = "";
      if (type == 'email') {
        domain = fieldStr.substring(fieldStr.lastIndexOf("@"));
        str = fieldStr.substring(0, fieldStr.lastIndexOf("@"));
      }
      str = '*'.repeat(str.length - digits) + str.slice(-digits) + domain;
      return str;
    }
  },
  beforeCreate: function () {
    $('body').addClass('login_body')
  },
  beforeRouteLeave: function (to, from, next) {
    clearInterval(randomImgSlide);
    clearInterval(randomImgLoaded);
    $('body').removeClass('login_body')
    next();
  },
  created () {
    window.addEventListener('resize', this.onResize, { passive: true })
    this.onResize()
  },
  beforeDestroy () {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, { passive: true })
    }
  },
}
